import { ThemeDefinition } from 'vuetify';

export const globalTheme = 'light';

export const isRTL = false;

export const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    textbase: '#DCDCDC',
    background: '#1c1c1c',
    surface: '#1B262C',
    primary: '#0096c7',
    button_primary: '#405C79',
    secondary: '#7db1ce',
    accent: '#59bbbb',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CA952',
    warning: '#FFC107',
    accepted: '#05c075',
    checkout: '#60b666',
    cta: '#0B9CED',
    promo: '#9CC28E',
    toggle: '#2b76b8',
  },
};

export const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    textbase: '#14141A',
    background: '#FFFFFF',
    modal_background: '#e7e7e7',
    surface: '#ffffff',
    panelbg: '#f6f6f6',
    toolbar: '#f9f9f9',
    // primary_dark: '#a2ddff',
    primary_dark: '#0096c7',
    primary_new: '#303474',
    secondary_new: '#58a4dc',
    button_primary: '#405C79',
    dicom_dark: '#122131',
    dicom_medium: '#1B2E43',
    dicom_light: '#405C79',
    primary: '#6875EC',
    secondary: '#344454',
    accent: '#009C96',
    anchor: '#E86D2A',
    error: '#ef476f',
    info: '#8B8B8B',
    selector: '#606298',
    popup: '#242e41',
    success: '#4CA952',
    success_light: '#bdf3c2',
    notification_success: '#14A44D',
    notification_warning: '#E4A11B',
    notification_error: '#DC4C64',
    warning: '#ffd166',
    accepted: '#05c075',
    checkout: '#60b666',
    cta: '#466d99',
    promo: '#9CC28E',
    toggle: '#A84F1E',

    // TEXT
    shark_050: '#f7f7f8',
    shark_200: '#d9d9de',
    shark_300: '#B9BAC0',
    shark_400: '#92939e',
    shark_600: '#5e5e6b',
    shark_950: '#1d1d20',

    // PRIMARY
    minsk_050: '#eff3fe',
    minsk_100: '#e1eafe',
    minsk_200: '#c9d7fc',
    minsk_500: '#6875ec',
    minsk_600: '#4c4fdf',
    minsk_900: '#2e3176',
    minsk_950: '#1d1d49',

    // SECONDARY
    picton_050: '#f2f8fd',
    picton_200: '#c3def4',
    picton_400: '#50a5de',
    picton_500: '#2b8bcc',
    picton_600: '#1c6ead',
    picton_700: '#18588c',

    // SUCCESS
    malachite_050: '#f2fdf0',
    malachite_100: '#DFFCDC',
    malachite_200: '#c1f7bb',
    malachite_500: '#2fc423',
    malachite_600: '#21a217',
    malachite_700: '#1D7F16',
    malachite_900: '#175314',

    // INFO
    viking_050: '#eefcfd',
    viking_100: '#d4f6f9',
    viking_200: '#aeedf3',
    viking_500: '#1ba9bf',
    viking_600: '#1988a1',
    viking_700: '#18588c',
    viking_900: '#1e4b5b',

    // WARNING
    lightning_050: '#fcfde9',
    lightning_100: '#fbfcc5',
    lightning_200: '#fbf98d',
    lightning_400: '#f5e12f',
    lightning_500: '#e4c50e',
    lightning_600: '#c59b09',
    lightning_700: '#9d700b',
    lightning_900: '#402608',

    // DANGER
    amaranth_050: '#fdf4f3',
    amaranth_100: '#fce7e8',
    amaranth_200: '#f8d3d4',
    amaranth_500: '#dc4756',
    amaranth_600: '#ca344a',
    amaranth_700: '#aa263d',
    amaranth_900: '#7a2136',

    //SURFACES
    white: '#ffffff',
    neutral: '#F7F7F8',
    dark: '#14141A',
  },
};

export default { globalTheme, isRTL, darkTheme, lightTheme };
